export default __webpack_public_path__ + "static/Tudor-5a88b18a842fd82d71afb3d576e4aa99.jpg";